/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { RevisionTaskNameEnum } from "./RevisionTaskNameEnum";
import {
  RevisionTaskNameEnumFromJSON,
  RevisionTaskNameEnumFromJSONTyped,
  RevisionTaskNameEnumToJSON,
  RevisionTaskNameEnumToJSONTyped,
} from "./RevisionTaskNameEnum";
import type { RevisionTaskStatusEnum } from "./RevisionTaskStatusEnum";
import {
  RevisionTaskStatusEnumFromJSON,
  RevisionTaskStatusEnumFromJSONTyped,
  RevisionTaskStatusEnumToJSON,
  RevisionTaskStatusEnumToJSONTyped,
} from "./RevisionTaskStatusEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedRevisionTask
 */
export interface PatchedRevisionTask {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  name?: RevisionTaskNameEnum;
  /**
   *
   */
  params?: any | null;
  /**
   *
   */
  readonly created?: Date;
  /**
   *
   */
  readonly lastUpdated?: Date;
  /**
   *
   */
  status?: RevisionTaskStatusEnum;
  /**
   *
   */
  detail?: any | null;
  /**
   *
   */
  readonly revision?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PatchedRevisionTask interface.
 */
export function instanceOfPatchedRevisionTask(value: object): value is PatchedRevisionTask {
  return true;
}

export function PatchedRevisionTaskFromJSON(json: any): PatchedRevisionTask {
  return PatchedRevisionTaskFromJSONTyped(json, false);
}

export function PatchedRevisionTaskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedRevisionTask {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"] == null ? undefined : RevisionTaskNameEnumFromJSON(json["name"]),
    params:
      json["params"] === undefined ? undefined : json["params"] === null ? null : json["params"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    lastUpdated: json["last_updated"] == null ? undefined : parseDateTime(json["last_updated"]),
    status: json["status"] == null ? undefined : RevisionTaskStatusEnumFromJSON(json["status"]),
    detail:
      json["detail"] === undefined ? undefined : json["detail"] === null ? null : json["detail"],
    revision: json["revision"] == null ? undefined : json["revision"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PatchedRevisionTaskToJSON(json: any): PatchedRevisionTask {
  return PatchedRevisionTaskToJSONTyped(json, false);
}

export function PatchedRevisionTaskToJSONTyped(
  value?: Omit<PatchedRevisionTask, "url" | "created" | "lastUpdated" | "revision" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: RevisionTaskNameEnumToJSON(value["name"]),
    params: value["params"],
    status: RevisionTaskStatusEnumToJSON(value["status"]),
    detail: value["detail"],
  };
}
